/* this file is transformed by vux-loader */
/* eslint-disable */
import _objectSpread from "/Users/pajk01/workspace/n34220_autoconfig_STATIC/vue-scrm_temp/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters, mapActions, mapMutations } from 'vuex';
import { MUTATION_USERINFO_SELECTVISITID, GETTER_USERINFO_VISITLIST, GETTER_USERINFO_SELECTVISITID, ACTION_USERINFO_VISITLIST_GET } from '@/store/mutation_types';
export default {
  props: {
    //是否允许编辑
    disabled: {
      type: Boolean,
      "default": false
    },
    //是否显示新增就诊人
    canAdd: {
      type: Boolean,
      "default": false
    },
    //是否弹出列表
    isShowList: {
      "default": false
    },
    isShowWhenNoVisit: {
      "default": true
    }
  },
  data: function data() {
    return {
      showList: this.isShowList
    };
  },
  created: function created() {},
  mounted: function mounted() {
    var _this = this;

    this.ACTION_USERINFO_VISITLIST_GET().then(function (data) {
      _this.$emit('reload', data);
    });
  },
  computed: _objectSpread(_objectSpread({}, mapGetters({
    visitList: GETTER_USERINFO_VISITLIST,
    selectVisitId: GETTER_USERINFO_SELECTVISITID
  })), {}, {
    selectIndex: function selectIndex() {
      var _this2 = this;

      return this.visitList.findIndex(function (e) {
        return e.empiId === _this2.selectVisitId;
      });
    },
    isShow: function isShow() {
      return !(!this.isShowWhenNoVisit && this.visitList.length === 0);
    },
    curVisitObj: function curVisitObj() {
      var _this3 = this;

      return this.visitList.find(function (e) {
        return e.empiId === _this3.selectVisitId;
      });
    }
  }),
  methods: _objectSpread(_objectSpread(_objectSpread({}, mapActions([ACTION_USERINFO_VISITLIST_GET])), mapMutations({
    setSelectVisitID: MUTATION_USERINFO_SELECTVISITID
  })), {}, {
    //电话号码
    mobilePhoneNumberMethod: function mobilePhoneNumberMethod(mobilePhoneNumber) {
      if (mobilePhoneNumber && mobilePhoneNumber != '' && mobilePhoneNumber != 'null') {
        return ' (' + mobilePhoneNumber + ')';
      } else {
        return '';
      }
    },
    //显示就诊人列表事件
    showVisitList: function showVisitList() {
      if (this.disabled) {
        return;
      }

      this.showList = !this.showList;
    },
    //选择就诊人事件
    visitLiEvent: function visitLiEvent(index) {
      this.setSelectVisitID({
        selectVisitId: this.visitList[index].empiId
      });
      this.showList = false;
      this.$emit('selected', this.visitList[index]);
    },
    //激活页面新增就诊人
    addVisitEvent: function addVisitEvent() {
      this.showList = false;
      this.$emit('added');
    }
  })
};